import axios from "axios";
import LanguageService from "@/services/LanguageService";
import Constants from "@/services/Constants";

export default {
	async getPosts(start) {
		let res = await axios.get(`${Constants.backend}/posts/${LanguageService.langId}/${start}`);
		return res.data;
	},
}